import { supabase } from './supabase';

export const ADMIN_EMAIL_ALLOWLIST: ReadonlyArray<string> = [
  'reisener@webnamic.de',
];

export type AuthRole = 'admin' | 'provider' | 'guest';

export type AuthState = {
  role: AuthRole;
  email: string | null;
  userId: string | null;
};

const isAdminEmail = (email: string | null): boolean => {
  if (!email) return false;
  return ADMIN_EMAIL_ALLOWLIST.includes(email.toLowerCase().trim());
};

export async function resolveAuthState(): Promise<AuthState> {
  const { data, error } = await supabase.auth.getUser();
  if (error || !data?.user) {
    return { role: 'guest', email: null, userId: null };
  }
  const email = data.user.email ?? null;
  const userId = data.user.id;
  return {
    role: isAdminEmail(email) ? 'admin' : 'provider',
    email,
    userId,
  };
}

export function syncAuthLocalStorageHints(state: AuthState): void {
  if (state.role === 'admin') {
    localStorage.setItem('adminLoggedIn', 'true');
  } else {
    localStorage.removeItem('adminLoggedIn');
  }
  if (state.role === 'provider') {
    localStorage.setItem('providerLoggedIn', 'true');
  } else {
    localStorage.removeItem('providerLoggedIn');
  }
}

export const PROVIDER_ONLY_PATHS: ReadonlySet<string> = new Set([
  '/provider-dashboard',
  '/provider-account-settings',
  '/provider-edit',
  '/provider-fachbeitrag-neu',
]);

export function isAdminPath(pathname: string): boolean {
  return pathname.startsWith('/admin');
}

export function isProviderPath(pathname: string): boolean {
  return PROVIDER_ONLY_PATHS.has(pathname);
}

export function isProtectedPath(pathname: string): boolean {
  return isAdminPath(pathname) || isProviderPath(pathname);
}
